/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Delete_ButtonInputs */

const en_preset_manager_delete_button = /** @type {(inputs: Preset_Manager_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const fr_preset_manager_delete_button = /** @type {(inputs: Preset_Manager_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

const de_preset_manager_delete_button = /** @type {(inputs: Preset_Manager_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen`)
};

const it_preset_manager_delete_button = /** @type {(inputs: Preset_Manager_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminare`)
};

const ru_preset_manager_delete_button = /** @type {(inputs: Preset_Manager_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить`)
};

const es_preset_manager_delete_button = /** @type {(inputs: Preset_Manager_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar`)
};

const zh_cn2_preset_manager_delete_button = /** @type {(inputs: Preset_Manager_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除`)
};

const ja_preset_manager_delete_button = /** @type {(inputs: Preset_Manager_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消去`)
};

const hi_preset_manager_delete_button = /** @type {(inputs: Preset_Manager_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मिटाना`)
};

const pt_pt2_preset_manager_delete_button = /** @type {(inputs: Preset_Manager_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Preset_Manager_Delete_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_delete_button = /** @type {((inputs?: Preset_Manager_Delete_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Delete_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_delete_button(inputs)
	if (locale === "de") return de_preset_manager_delete_button(inputs)
	if (locale === "it") return it_preset_manager_delete_button(inputs)
	if (locale === "ru") return ru_preset_manager_delete_button(inputs)
	if (locale === "es") return es_preset_manager_delete_button(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_delete_button(inputs)
	if (locale === "ja") return ja_preset_manager_delete_button(inputs)
	if (locale === "hi") return hi_preset_manager_delete_button(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_delete_button(inputs)
	return en_preset_manager_delete_button(inputs)
});